// extracted by mini-css-extract-plugin
export default {"container":"FootballTable_container__bg0VS"};